import { createRouter, createWebHistory } from 'vue-router'
import AppLayout from '../layouts/AppLayout.vue'
import EntryView from '../views/EntryView.vue'
import ErrorView from '../views/ErrorView.vue'
import FolderView from '../views/FolderView.vue'
import FormView from '../views/FormView.vue'
import HomeView from '../views/HomeView.vue'
import ProfileView from '../views/ProfileView.vue'
import SetupView from '../views/SetupView.vue'
import SettingsView from '../views/SettingsView.vue'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/entry', component: EntryView },
    { path: '/setup', component: SetupView },
    { path: '/error', component: ErrorView },
    {
      path: '/',
      component: AppLayout,
      children: [
        { path: '', name: 'home', component: HomeView },
        { path: 'folders/:folderId', name: 'folder', component: FolderView },
        { path: 'forms/:publicKey', name: 'form', component: FormView },
        { path: 'profile', name: 'profile', component: ProfileView },
        { path: 'settings', name: 'settings', component: SettingsView },
      ],
    },
  ],
})
